import React from 'react';
import PropTypes from 'prop-types';
import CartIcon from '@tradera/tradera-ui/icons/cart.svg?jsx';

const CartLink = ({ isLoggedIn, formattedCartItems, cartSum }) => {
    return (
        <a
            href="/Shopping/CartOverview"
            aria-label="Mitt Tradera"
            className="d-flex slim-header__menu-link slim-header__cart-link px-3"
            data-ga-category="Header"
            data-ga-action="Navigation"
            data-ga-label="Cart with items">
            <div className="position-relative d-flex align-items-center">
                <CartIcon className="icon icon-dark" />
                <span className="slim-header__notification slim-header__notification-cart">
                    {formattedCartItems}
                </span>
            </div>
            <div className={`slim-header__link-text d-none ${
                isLoggedIn ? 'd-lg-inline' : 'd-xl-inline'
            }`}>
                <span className="bold">
                    Varukorg: <br />
                    {cartSum} kr
                </span>
            </div>
        </a>
    );
};

CartLink.propTypes = {
    isLoggedIn: PropTypes.bool,
    formattedCartItems: PropTypes.number,
    cartSum: PropTypes.string
};

export default CartLink;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/site-header/cart-link.jsx